export default "__VITE_ASSET__CitojPxi__"